import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Chip from "@material-ui/core/Chip";
import { Box, Tooltip } from "@material-ui/core";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  chips: {
    display: "flex",
    flexWrap: "nowrap",
    gap: 4,
    alignItems: "center",
    overflow: "hidden",
  },
  chip: {
    margin: 0,
    maxWidth: "70px",
    flexShrink: 1,
    "& .MuiChip-label": {
      padding: "0 6px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      display: "block",
    },
  },
  chipCounter: {
    margin: 0,
    minWidth: "30px",
    flexShrink: 0,
    "& .MuiChip-label": {
      padding: "0 4px",
    },
  },
  select: {
    height: 40,
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: "10px",
    },
  },
}));

const QueueSelect = ({ selectedQueueIds, onChange, disabled = false }) => {
  const classes = useStyles();
  const [queues, setQueues] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/queue");
        setQueues(data);
      } catch (err) {
        toastError(err);
      }
    })();
  }, []);

  const handleChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <Box>
      <FormControl fullWidth margin="dense" variant="outlined" size="small">
        <InputLabel>{i18n.t("queueSelect.inputLabel")}</InputLabel>
        <Select
          multiple
          labelWidth={60}
          value={selectedQueueIds}
          onChange={handleChange}
          disabled={disabled}
          size="small"
          className={classes.select}
          MenuProps={{
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "left",
            },
            getContentAnchorEl: null,
          }}
          renderValue={(selected) => {
            if (selected.length === 0) return null;
            
            const firstQueue = queues.find((q) => q.id === selected[0]);
            if (!firstQueue) return null;
            
            const remainingCount = selected.length - 1;

            return (
              <div className={classes.chips}>
                <Tooltip title={firstQueue.name} arrow placement="top">
                  <Chip
                    style={{ backgroundColor: firstQueue.color }}
                    variant="outlined"
                    label={firstQueue.name}
                    size="small"
                    className={classes.chip}
                  />
                </Tooltip>
                {remainingCount > 0 && (
                  <Tooltip 
                    title={`${remainingCount} ${remainingCount === 1 ? 'fila adicional' : 'filas adicionais'}`}
                    arrow 
                    placement="top"
                  >
                    <Chip
                      variant="outlined"
                      label={`+${remainingCount}`}
                      size="small"
                      className={classes.chipCounter}
                    />
                  </Tooltip>
                )}
              </div>
            );
          }}
        >
          {queues.map((queue) => (
            <MenuItem key={queue.id} value={queue.id}>
              {queue.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default QueueSelect;
